
<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    scrollable
    max-width="800px"
  >
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn color="primary" icon variant="text" v-bind="props"
        ><v-icon class="mr-2">mdi-eye</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-toolbar color="primary" :title="value.name">
        <v-btn color="black" @click="dialog = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h3>Mensagem:</h3>
            <div>
              {{ value.message }}
            </div>
          </v-col>
          <v-col cols="12" v-if="value.attachments">
            <h3>Arquivos Anexos:</h3>
            <div
              v-for="(newsAttachment, ixfl) in value.attachments"
              :key="ixfl"
            >
              <v-list-item :title="newsAttachment?.file?.original_name">
                <template
                  v-slot:append
                  v-if="value.status == 1 || value.status == 0"
                >
                  <v-btn
                    :disabled="requestingApi"
                    color="red"
                    variant="text"
                    icon
                    size="medium"
                    class="ml-2"
                    density="compact"
                    @click="deleteFile(newsAttachment, ixfl)"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </template>
                <template v-slot:prepend>
                  <v-btn
                    :disabled="requestingApi"
                    color="primary"
                    variant="text"
                    icon
                    size="medium"
                    class="mr-2"
                    density="compact"
                    @click="downloadFile(newsAttachment.file)"
                    ><v-icon>mdi-download</v-icon></v-btn
                  >
                </template>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
    modelValue: Object,
    floatRight: Boolean,
    hideButton: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {},
  activated() {},
  methods: {
    downloadFile(file) {
      window.open(file.path, "_blank");
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    dialog(newVal) {
      var vm = this;
      if (newVal) {
        return new Promise((resolve, reject) => {
          api.news
            .view(vm.value.id)
            .then((result) => {})
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
        });
      } else {
        vm.$emit('viewed')
      }
    },
  },
};
</script>
